import Link from "next/link";

type LogoProps = {
    href: string
    className?: string
}
export default function Logo(props: LogoProps) {
    return (
        <Link href={props.href} className={`site-logo ${props.className ?? ''}`}>
            <span className="logo-easy">Easy</span>
            <span className="logo-odds">Odds</span>
        </Link>
    )
}
